import { BaseCategory } from "./BaseCategory";
import { AuthoringBlockType, ConnectorType, ElementTextBlockPositionType, HeaderPositionType, NodeType, PaletteColorType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class LinearDiagramCategory extends BaseCategory {
    get name() {
        return "Linear Diagram";
    }

    get type() {
        return SlideCategories.LINEAR_DIAGRAM;
    }

    get icon() {
        return null;
    }

    get description() {
        return `The content describes a linear process flow or sequence of 2-10 steps with a clear starting point to a final endpoint For more complex flowcharts, use FlowChart category. For hierarchies or hub-and-spoke diagrams, use Hierarchy Diagram category. For filtering processes, use Funnel category.`;
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Parse the content to determine the steps, stages, or items in the sequence and list those items in order. You MUST include at least 2 items, and up to 10 items if the content supports it.
         Separate any additional content into the conclusion`;
    }

    getPromptSchema(options = {}) {
        return {
            items: this.getItemListSchema(options),
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    getSlideModels(model) {
        return this.buildModels([
            // this.buildArrowCycle(model),
            this.buildProcessDiagram(model),
            // this.buildIconCycle(model)
        ]);
    }

    buildProcessDiagram(model) {
        let builder = new SlideModelBuilder("step_chevrons", model, ["process", "sequence", "flow"].includes(model.hints?.diagramType));
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "theme-to-dark",
            items: model.items.map(item => ({
                ...builder.createIcon(item.icon),
                text: builder.createSingleBlockText(item.title, TextStyleType.TITLE),
                body: builder.createSingleBlockText(item.description, TextStyleType.BODY),
            })),
            textLayout: "below",
            ornament: model.items.some(i => i.icon) ? "icon" : "number",
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }
        return builder;
    }

    buildArrowCycle(model) {
        let builder = new SlideModelBuilder("cycle_diagram", model, ["cycle"].includes(model.hints?.diagramType));
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "colorful",
            columns: model.items.length <= 4 ? "right" : "split",
            items: model.items.map(item => ({
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
            textLayout: "below"
        };

        if (model.hub) {
            primary.showCenterText = true;
            primary.centerText = builder.createSingleBlockText(model.hub);
        }

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }
        return builder;
    }

    buildIconCycle(model) {
        let builder = new SlideModelBuilder("step_circular", model, ["cycle"].includes(model.hints?.diagramType));
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.LEFT, backgroundColor: PaletteColorType.BACKGROUND_ACCENT });

        let primary = {
            collectionColor: "colorful",
            clockwise: true,
            items: model.items.map(item => ({
                nodeType: NodeType.CONTENT_AND_TEXT,
                ...builder.createIcon(item.icon ?? "star"),
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        // builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.INLINE);
        }
        return builder;
    }
}

